import EventBus from "js-event-bus";

window.app = new EventBus();
